import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import { FaCashRegister } from "react-icons/fa6";

const RegisterIcon = () => {
  const currentTheme = useSelector((state: RootState) => state.theme.mode);
  const fillColor = currentTheme == "light" ? "#1D1D1B" : "#ffffff";
  
  return (
    <FaCashRegister
      color={fillColor}
      style={{ width: '145px', height: '110px' }}
    />
  );
};

export { RegisterIcon };
